<template>
  <div>
    <button
      class="btn"
      :class="button_class"
      :name="button_name"
      :style="{ pointerEvents: pointerEvent }"
      :type="buttonType"
      value="true"
      @click="disable"
    >
      <span v-show="!disabled" class="ch-NextButton_Text">{{ active_text }}</span>
      <span v-show="disabled">
        <i class="spinner-border spinner-border-sm"></i>
        <span class="ch-NextButton_WaitText">{{ inactive_text }}</span>
      </span>
    </button>
    <slot name="confirmation"></slot>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ButtonCheckoutMixin from "./ButtonCheckoutMixin";

export default {
  name: "ButtonCheckoutConfirm",
  mixins: [ButtonCheckoutMixin],
  props: {
    confirmation_needed: {
      type: Boolean,
      required: true,
    },
    terms_needed: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      termsAccepted: "checkout/termsAccepted",
    }),
    buttonType() {
      return this.confirmation_needed ? "button" : "submit";
    },
  },
  methods: {
    ...mapActions({
      showModal: "showModal",
      setReportTermsValidity: "checkout/setReportTermsValidity",
    }),
    disable() {
      let termsFulfilled = this.termsAccepted || !this.terms_needed;
      if (termsFulfilled && this.confirmation_needed) {
        this.showModal("checkoutConfirmationModal");
      } else if (termsFulfilled) {
        this.disableButtons();
      } else {
        this.setReportTermsValidity(true);
      }
    },
    disableButtons() {
      this.setPointerEvent("none");
      this.setButtonsDisabled(true);
    },
  },
};
</script>
